import battlemapsData from '../data/battlemaps.json';

const DEFAULT_BATTLEMAP_ENVIRONMENT = 'forest-grasslands';

export const BATTLEMAP_ENVIRONMENTS = [
  { id: 'forest-grasslands', label: 'Forest / Grasslands' },
  { id: 'arctic', label: 'Arctic' },
  { id: 'dungeon', label: 'Dungeon' },
  { id: 'beach-water', label: 'Beach / Water' },
  { id: 'mountain', label: 'Mountain' },
  { id: 'building', label: 'Building' },
  { id: 'other', label: 'Other' },
];

function buildBattlemapCatalogAndById(raw) {
  const byId = {};
  const catalog = [];

  for (const entry of raw) {
    if (entry.id === 'none') {
      const leaf = {
        id: 'none',
        name: entry.name,
        environment: null,
        gridWidth: entry.gridWidth,
        gridHeight: entry.gridHeight,
        thumbnail: entry.thumbnail,
        fullImage: entry.fullImage,
      };
      catalog.push({ kind: 'single', ...leaf });
      byId.none = { ...leaf };
      continue;
    }

    const env = entry.environment || DEFAULT_BATTLEMAP_ENVIRONMENT;

    if (Array.isArray(entry.variations) && entry.variations.length > 1) {
      const variations = entry.variations.map((v) => ({
        id: v.id,
        name: v.name,
        label: v.label ?? null,
        gridWidth: v.gridWidth,
        gridHeight: v.gridHeight,
        thumbnail: v.thumbnail,
        fullImage: v.fullImage,
      }));
      catalog.push({
        kind: 'group',
        id: entry.id,
        name: entry.name,
        environment: env,
        variations,
      });
      for (const v of variations) {
        byId[v.id] = {
          id: v.id,
          name: v.name,
          label: v.label,
          environment: env,
          gridWidth: v.gridWidth,
          gridHeight: v.gridHeight,
          thumbnail: v.thumbnail,
          fullImage: v.fullImage,
          groupId: entry.id,
        };
      }
      continue;
    }

    if (Array.isArray(entry.variations) && entry.variations.length === 1) {
      const v = entry.variations[0];
      const leaf = {
        id: v.id,
        name: v.name,
        label: v.label ?? null,
        environment: env,
        gridWidth: v.gridWidth,
        gridHeight: v.gridHeight,
        thumbnail: v.thumbnail,
        fullImage: v.fullImage,
        groupId: entry.id,
      };
      catalog.push({ kind: 'single', ...leaf });
      byId[v.id] = { ...leaf };
      continue;
    }

    const leaf = {
      id: entry.id,
      name: entry.name,
      environment: env,
      gridWidth: entry.gridWidth,
      gridHeight: entry.gridHeight,
      thumbnail: entry.thumbnail,
      fullImage: entry.fullImage,
    };
    catalog.push({ kind: 'single', ...leaf });
    byId[entry.id] = { ...leaf };
  }

  return { catalog, byId };
}

const { catalog: battlemapCatalogBuilt, byId: battlemapByIdBuilt } =
  buildBattlemapCatalogAndById(battlemapsData);

export const BATTLEMAP_CATALOG = battlemapCatalogBuilt;
export const BATTLEMAPS = BATTLEMAP_CATALOG;
export const BATTLEMAP_BY_ID = battlemapByIdBuilt;

export const getBattlemapById = (battlemapId) => BATTLEMAP_BY_ID[battlemapId];
export const getBattlemapImageUrl = (battlemapId) =>
  BATTLEMAP_BY_ID[battlemapId]?.fullImage;
export const getBattlemapThumbnail = (battlemapId) =>
  BATTLEMAP_BY_ID[battlemapId]?.thumbnail;
